import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RatesComponent } from './pages/rates/rates.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { RoleRedirectGuard } from 'src/app/guards/role.guard';
import { MenuAccessGuard } from 'src/app/guards/menu-access.guard';

const routes: Routes = [
  { path: '', component: RatesComponent, canActivate: [AuthGuard, RoleRedirectGuard, MenuAccessGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RatesTrackRoutingModule {}
